import React from 'react';
import './page-loading-shell.scss';

const SKELETON_ROWS = [0, 1, 2, 3, 4, 5];
const SKELETON_TABS = [0, 1, 2, 3, 4];
const SKELETON_HEAD_CELLS = [0, 1, 2, 3, 4, 5];

/** Shimmer placeholder for list pages (My Quotes, My Orders). */
export default function ListPageSkeleton() {
  return (
    <div className="list-page-skeleton" aria-hidden="true">
      <div className="inner-content">
        <div className="my-quotes list-page-skeleton__inner">
          <div className="container">
            <div className="page-box">
              <div className="page-box-inner">
                <div className="list-page-skeleton__toolbar">
                  <div className="list-page-skeleton__searchGroup">
                    <span className="list-page-skeleton__search" />
                    <span className="list-page-skeleton__calendar" />
                  </div>
                </div>
                <div className="list-page-skeleton__tabs">
                  {SKELETON_TABS.map((key) => (
                    <span key={key} className="list-page-skeleton__tab" />
                  ))}
                </div>
                <div className="list-page-skeleton__table">
                  <div className="list-page-skeleton__head">
                    {SKELETON_HEAD_CELLS.map((key) => (
                      <span key={key} className="list-page-skeleton__headCell" />
                    ))}
                  </div>
                  <div className="list-page-skeleton__rows">
                    {SKELETON_ROWS.map((rowKey) => (
                      <div key={rowKey} className="list-page-skeleton__row">
                        {SKELETON_HEAD_CELLS.map((cellKey) => (
                          <span key={cellKey} className="list-page-skeleton__cell" />
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
